import React, { useState } from "react";
import MobileHeader from "../components/MobileHeader";
import userStore from "../../zustand/user.store";
import styles from "./MobileContact.module.scss";

const MobileContact = () => {
  const { user } = userStore((state) => ({ user: state.user }));
  const [form, setForm] = useState({
    name: user?.firstname ? `${user.firstname} ${user.lastname || ""}`.trim() : "",
    email: user?.email || "",
    subject: "",
    message: "",
  });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const handleChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) return;
    setSending(true);
    try {
      const res = await fetch("https://forplay.co.il/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: form.name,
          email: form.email,
          subject: form.subject,
          message: form.message,
        }),
      });
      if (res.ok) {
        setSent(true);
        setForm((prev) => ({ ...prev, subject: "", message: "" }));
      }
    } catch (_) {}
    setSending(false);
  };

  return (
    <div className={styles.page}>
      <MobileHeader title="Contact Us" />
      <form className={styles.form} onSubmit={handleSubmit}>
        <div className={styles.field}>
          <label className={styles.label}>Name</label>
          <input
            className={styles.input}
            value={form.name}
            onChange={handleChange("name")}
            placeholder="Your name"
          />
        </div>
        <div className={styles.field}>
          <label className={styles.label}>Email</label>
          <input
            className={styles.input}
            type="email"
            value={form.email}
            onChange={handleChange("email")}
            placeholder="Your email"
          />
        </div>
        <div className={styles.field}>
          <label className={styles.label}>Subject</label>
          <input
            className={styles.input}
            value={form.subject}
            onChange={handleChange("subject")}
            placeholder="What is this about?"
          />
        </div>
        <div className={styles.field}>
          <label className={styles.label}>Message</label>
          <textarea
            className={styles.textarea}
            value={form.message}
            onChange={handleChange("message")}
            placeholder="How can we help?"
            rows={5}
          />
        </div>
        {sent && <p className={styles.success}>Message sent successfully!</p>}
        <button className={styles.submitBtn} type="submit" disabled={sending || !form.message}>
          {sending ? "Sending..." : "Send Message"}
        </button>
      </form>
    </div>
  );
};

export default MobileContact;
